<div
  id="reminderFilterDropdown"
  class="siteFilters__dropdown"
  data-test="reminderFilterDropdown"
  (ppOnRendered)="onFilterDropdownRendered($event)"
>
  <pp-button-dropdown
    [ppSrc]="EIconPath.ICON_TABLE_FILTER"
    [ppText]="'filters' | ppTranslate"
    [ppNumber]="displayedSelectedFiltersValue"
    [ppActive]="displayedSelectedFiltersValue.length > 0 || isDropdownVisible"
    (ppAction)="toggleDropdown()"
    data-m-target="Filter dropdown button"
    id="reminderFilterDropdownBtn"
  />

  <pp-filter-dropdown
    [ppShow]="isDropdownVisible"
    ppAlign="left"
    [ppFullWidth]="true"
    [ppMinWidth]="'50rem'"
  >
    @if (isDropdownVisible) {
      <header class="reminderFilterDropdown__header">
        <div class="reminderFilterDropdown__headerContent">
          <h6 class="reminderFilterDropdown__title">
            {{ 'filter_by' | ppTranslate }}
            <pp-icon
              ppTooltip
              [ppTitle]="'advanced_filter_tooltip' | ppTranslate"
              [ppSVG]="badgeIcon"
              ppColor="grey-600"
              ppClass="setSize14"
              [ppMobileTooltip]="true"
            />
          </h6>
        </div>
      </header>
    }
    <div #reminderFilterDropdown class="remindersFilter__container">
      <div class="remindersFilter">
        <div class="remindersFilter__inner">
          <section class="remindersFilter__row">
            <header class="remindersFilter__header">
              {{ 'reminder' | ppTranslate | titlecase }}
            </header>
          </section>

          <section class="remindersFilter__row">
            <div class="remindersFilter__list">
              <pp-reminder-options-list [(ppOptions)]="typeOptions" />

              <pp-reminder-options-list [(ppOptions)]="statusOptions" />

              <pp-reminder-options-list [(ppOptions)]="linkedToOptions" />
            </div>
          </section>

          <section class="remindersFilter__row">
            <section class="reminderOptionsList reminderOptionsList--dueDate">
              <header class="reminderOptionsList__header">
                {{ 'reminder_filter_due_date' | ppTranslate }}
              </header>

              <section class="reminderOptionsList__options reminderOptionsList__options--dueDate">
                <pp-datepicker
                  class="reminderOptionsList__datepicker"
                  [ppDate]="dueDateOptions.from"
                  (ppSelect)="onDateChange($event, 'from')"
                  [ppPlaceholder]="'from' | ppTranslate"
                />

                <pp-datepicker
                  class="reminderOptionsList__datepicker"
                  [ppDate]="dueDateOptions.to"
                  (ppSelect)="onDateChange($event, 'to')"
                  [ppPlaceholder]="'to' | ppTranslate"
                />
              </section>
            </section>
          </section>
        </div>
      </div>
    </div>

    <footer class="reminderFilterDropdown__footer">
      <div class="reminderFilterDropdown__buttons">
        <button
          id="reminderFilterDropdownCancelBtn"
          class="reminderFilterDropdown__cancel"
          (click)="clearFilters()"
        >
          {{ 'clear_all' | ppTranslate }}
        </button>

        <pp-button
          ppStyle="primary"
          ppSize="large"
          ppId="reminderFilterDropdownApplyBtn"
          (ppAction)="hideDropdown(true)"
        >
          {{ 'done' | ppTranslate }}
        </pp-button>
      </div>
    </footer>
  </pp-filter-dropdown>
</div>
